type TState = any;

export type TTelemetryEvent = {
  consumedAt: string;
  id: string;
  serviceLevel: number;
  shipmentId: string;
  state: TState;
  thingName: string;
  timestamp: number;
  type: string;
};

export const EVENT_TYPES = [
  'ADDONS_ALERT_SHOCK',
  'ALERT_BOX_CODE',
  'ALERT_BOX_VIOLATION',
  'ALERT_HUMIDITY',
  'ALERT_PRESSURE',
  'ALERT_SECURITY_INSPECTION',
  'ALERT_SHOCK',
  'ALERT_TEMPERATURE',
  'BATTERY_INFO',
  'BATTERY_STATE_LOW',
  'BOX_CLOSED',
  'BOX_INFO',
  'BOX_LOCK_STATE',
  'BOX_LOCKED',
  'BOX_OPENED',
  'BOX_REGISTERED',
  'BOX_STARTUP',
  'BOX_UNLOCKED',
  'CAMERA',
  'CONNECTION',
  'CONNECTION_BLE_ESTABLISHED',
  'CONNECTION_BLE_LOST',
  'CONTRACT_ACTIVATED',
  'CONTRACT_DEACTIVATED',
  'DIAG_FUEL_GAUGE',
  'DISCONNECTION',
  'EXTERNAL_HUMIDITY_EXCEEDED',
  'EXTERNAL_TEMPERATURE_EXCEEDED',
  'FAILURE',
  'FLIGHT_MODE_DIAG_EVENT',
  'GEOLOCATION_INFO',
  'GPS_ACQUIRE',
  'INTERNAL_HUMIDITY_EXCEEDED',
  'INTERNAL_TEMPERATURE_EXCEEDED',
  'LABEL_WRITTEN',
  'PRESSURE_EXCEEDED',
  'SCALE_VALUE_CHANGED',
  'SCREEN_CHANGED',
  'SENSOR_ACQUIRE',
  'SHOCK_EXCEEDED',
  'TRANSFER_OF_HOLDER',
  'WEIGHT_REQUESTED',
];

export type TModifiedEvent = {
  parsedTimestamp: string;
} & TTelemetryEvent;
